/**
 * Publishes the height of the stacked sticky chrome as CSS custom properties.
 *
 * The header and the category nav both stick, one under the other, and their
 * combined height is not knowable in CSS: it moves with the merchant's logo
 * size, the announcement bar, and how many lines the nav wraps to.
 *
 * Anything that needs to park below them — the nav itself, the collection
 * toolbar, the FAQ's sticky heading — reads `--sticky-offset` instead of
 * measuring the header again in its own section. One measurement, one source
 * of truth, and adding a third sticky bar later means editing one file.
 *
 * Only `top` offsets depend on these values, so nothing reflows if the script
 * is late; the bars simply sit at their fallback until it runs.
 */
(function () {
  const root = document.documentElement;

  function measure() {
    const header = document.querySelector('.shopify-section.section--header');
    const nav = document.querySelector('.shopify-section.section--main-nav');

    const headerH = header ? Math.round(header.getBoundingClientRect().height) : 0;
    const navH = nav ? Math.round(nav.getBoundingClientRect().height) : 0;

    root.style.setProperty('--header-h', `${headerH}px`);
    root.style.setProperty('--nav-h', `${navH}px`);

    // The header sits at top: -1px so an observer can detect when it sticks;
    // everything below it inherits that one-pixel shift.
    root.style.setProperty('--sticky-offset', `${Math.max(headerH + navH - 1, 0)}px`);
  }

  measure();

  if ('ResizeObserver' in window) {
    const observer = new ResizeObserver(measure);
    ['.shopify-section.section--header', '.shopify-section.section--main-nav'].forEach((selector) => {
      const el = document.querySelector(selector);
      if (el) observer.observe(el);
    });
  }

  window.addEventListener('resize', measure);
  document.addEventListener('DOMContentLoaded', measure);

  // The theme editor swaps section markup without a page load.
  document.addEventListener('shopify:section:load', measure);
  document.addEventListener('shopify:section:unload', measure);
})();
